import {
    Button,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Col,
    FormGroup,
    Input,
    ListGroupItem,
    Media, ModalBody,
    Row, Spinner
} from "reactstrap";
import { selectThemeColors } from "../../../utility/Utils";
import React, { Fragment, useEffect, useState } from "react";
import { ReactSortable } from "react-sortablejs";
import NewGroupModal from "./NewGroupModal";
import axios from "axios";

import { useHistory, useLocation, useParams } from "react-router-dom";
import FooterButtons, { fixFooterButtons } from "../../components/FooterButtons";
import PlayoffScreen from "./PlayoffScreen";
import LeagueScreen from "./LeagueScreen";
import { useStore } from "react-redux";
import Tournament from "round-robin-tournament";
import dots from "../../../assets/dots.png";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { isArray } from "leaflet/src/core/Util";
import Select from "react-select";
import { BergerCreator } from "./BergerCreator";

const MySwal = withReactContent(Swal)

let robin = require('roundrobin');

export function getSportName(name) {
    if (!name) return "";
    if (name === "Atletika") {
        return "Athletics"
    }
    if (name === "Badminton") {
        return "Badminton"
    }
    if (name === "Košarka") {
        return "Basketball"
    }
    if (name === "Košarka 3v3") {
        return "Basketball3v3"
    }
    if (name === "Odbojka na pijesku") {
        return "Beach Volleyball"
    }
    if (name === "Šah") {
        return "Chess"
    }
    if (name === "E-sport") {
        return "Esport"
    }
    if (name === "Nogomet") {
        return "Football"
    }
    if (name === "Rukomet") {
        return "Handball"
    }
    if (name === "Judo") {
        return "Judo"
    }
    if (name === "Karate") {
        return "Karate"
    }
    if (name === "Kickboxing") {
        return "Kickboxing"
    }
    if (name === "Squash") {
        return "Squash"
    }
    if (name === "Plivanje") {
        return "Swimming"
    }
    if (name === "Stolni tenis") {
        return "Table tennis"
    }
    if (name === "Taekwondo") {
        return "Taekwondo"
    }
    if (name === "Tenis") {
        return "Tennis"
    }
    if (name === "Odbojka") {
        return "Volleyball"
    }
    if (name === "Vaterpolo") {
        return "Waterpolo"
    }
    return name
}

function makeId(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
    }
    return result;
}

export function isSportWithDisciplines(competition) {
    if (!competition || !competition.sport) {
        return false;
    }
    return competition.sport.name === "Judo" ||
        competition.sport.name === "Karate" ||
        competition.sport.name === "Kickboxing" ||
        competition.sport.name === "Atletika" ||
        competition.sport.name === "Taekwondo" ||
        competition.sport.name === "Swimming" ||
        competition.sport.name === "Plivanje";

}

export function isOneToOneSport(competition, forceTeam) {
    if (forceTeam === true) {
        return false;
    }
    if (!competition || !competition.sport) {
        return false;
    }
    return competition.sport.name === "Badminton" ||
        competition.sport.name === "Basketball" ||
        competition.sport.name === "Basketball3v3" ||
        competition.sport.name === "Chess" ||
        competition.sport.name === "Šah" ||
        competition.sport.name === "Judo" ||
        competition.sport.name === "Karate" ||
        competition.sport.name === "Kickboxing" ||
        competition.sport.name === "Squash" ||
        competition.sport.name === "Table Tennis" ||
        competition.sport.name === "Stolni tenis" ||
        competition.sport.name === "Taekwondo" ||
        competition.sport.name === "Table tennis";
}


export function getPlayersFromTeams(myTeams, competitionId, myPhaseDiscipline) {
    let myPlayers = []
    myTeams.map((singleTeam) => {
        singleTeam.players.map((singlePlayer) => {
            let isApproved = false;
            singlePlayer.competitionApproval.map((oneApproval) => {
                if (oneApproval.isApproved === true && oneApproval.competitionId === competitionId) {
                    isApproved = true;
                }
            })
            if (singleTeam.disciplines) {
                singleTeam.disciplines.map((oneDiscipline) => {
                    let disciplineCondition = !myPhaseDiscipline || (oneDiscipline.discipline.includes(myPhaseDiscipline))
                    if (oneDiscipline.player === singlePlayer._id && disciplineCondition) {
                        singlePlayer.discipline = oneDiscipline.discipline;
                    }
                })
            }
            let playerHasDisciplineSet = !myPhaseDiscipline || singlePlayer.discipline != null;

            if (isApproved && playerHasDisciplineSet) {
                singlePlayer.customTeam = singleTeam.shortName
                myPlayers.push(singlePlayer)
            }
        })
    })
    return myPlayers;
}

export function isAtletikaPlivanje(competition) {
    let isThisSport = false;
    if (competition && (
        competition.sport.name === "Atletika" ||
        competition.sport.name === "Plivanje" ||
        competition.sport.name === "Athletics" ||
        competition.sport.name === "Swimming"
    )) {
        isThisSport = true;
    }
    return isThisSport;
}

const CompetitionPhase = () => {
    let location = useLocation();
    const history = useHistory();
    const [competition, setCompetition] = useState(null);
    const [typeOfPhase, setTypeOfPhase] = useState(location.state ? location.state.typeOfPhase : null);
    const [teamDiscipline, setTeamDiscipline] = useState(location.state ? location.state.teamDiscipline : false)
    const [isDragDrop, setIsDragDrop] = useState(true);
    const [isBerger, setIsBerger] = useState(location.state && location.state.isBerger);
    const [hideFooter, setHideFooter] = useState(false);
    const [uzvrati, setUzvrati] = useState(location.state && location.state.uzvrati);
    const [numberOfTeams, setNumberOfTeams] = useState(location.state ? location.state.numberOfTeams : 0);
    const [duration, setDuration] = useState(location.state ? location.state.duration : 0);
    const [forceTeamSport, setForceTeamSport] = useState((location.state && location.state.teamSport) ? location.state.teamSport : false);
    const [isEditPlayoff, setIsEditPlayoff] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isNewGroupModalOpen, setIsNewGroupModalOpen] = useState(false);
    const [groups, setGroups] = useState([]);
    const [games, setGames] = useState([]);
    const [isThirdPlaceGameButton, setIsThirdPlaceGameButton] = useState()
    const [isThirdPlaceGame, setIsThirdPlaceGame] = useState(false)
    const [gameThirdPlace, setGameThirdPlace] = useState()
    const [loading, setLoading] = useState(false);
    const [fazaPrijenosBodova, setFazaPrijenosBodova] = useState("");
    const [preparedPhases, setPreparedPhases] = useState("");
    const [currentEditingPhase, setCurrentEditingPhase] = useState("");
    const [isEditingGroups, setIsEditingGroups] = useState(false);
  
    console.log("Games", games)
    console.log("Game third place", gameThirdPlace)
    console.log("Number of teams", numberOfTeams)
    console.log("Location", location)

    const params = useParams();

    const [allTeams, setAllTeams] = useState([]);
    const [allTeamsPreserved, setAllTeamsPreserved] = useState([]);


    const getNumberOfGamesInARound = (round) => {
        let numberOfGames = (numberOfTeams) / (Math.pow(2, round));
        return numberOfGames;
    }

    const getNumberOfRounds = () => {
        return Math.log2(numberOfTeams);
    }
    const preparePlayoffGames = (competition) => {
        let myIndex = 0;
        let games = [];
        for (let i = 1; i <= getNumberOfRounds(); i++) {
            let round = []
            for (let j = 0; j < getNumberOfGamesInARound(i); j++) {
                let arrayToPush = [
                    {},
                    {}
                ]

                round.push(
                    {
                        teams: arrayToPush,
                        location: "",
                        customId: makeId(20)
                    })
                myIndex = myIndex + 2
            }
            games.push(round);
        }
        setGames(games);
        console.log("preparePlayoffGames games", games)
    }

  
    

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const editingGroupsParam = urlParams.get('editing');
        let myPhaseLocal = null
        if (editingGroupsParam && !isEditingGroups) {
            setIsEditingGroups(true);
        }
        if (!isDataLoaded) {
            setIsDataLoaded(true)
            let isEditLocal = false;
            let isLocalPlayoff = false;
            axios.get(`${process.env.REACT_APP_MAIN_URL}/admin/get-one-competition?competitionId=${params.competitionId}`)

                .then((firstResult) => {
                    setCompetition(firstResult.data.competition);
                    let preparedPhases = firstResult.data.competition.phases.map((singlePhase) => {
                        return {
                            label: singlePhase.name,
                            value: singlePhase
                        }
                    })
                    setPreparedPhases(preparedPhases);
                    firstResult.data.competition.phases.map((singlePhase) => {
                        if (singlePhase.name === params.phaseName) {
                            setCurrentEditingPhase(singlePhase)
                            myPhaseLocal = singlePhase;
                            if (singlePhase.playoff) {
                                isEditLocal = true;
                                setIsEditPlayoff(true);
                                isLocalPlayoff = true;
                            }
                            if (singlePhase.isBerger) {
                                setIsBerger(true);
                            }
                            if (singlePhase.halfTimeDuration) {
                                setDuration(true);
                            }
                            if (singlePhase.hasReturnMatches) {
                                setUzvrati(true);
                            }
                            if (singlePhase.playoff && singlePhase.playoff.games) {
                                let gamesPlayoff = singlePhase.playoff.games.filter(game => !game.game.isThirdPlace)
                                console.log("Single phase playoff games", singlePhase.playoff.games)
                                console.log("Single phase playoff games just playoff", gamesPlayoff)

                                setNumberOfTeams(gamesPlayoff.length + 1);
                            }
                            if (singlePhase.playoff) {
                                setTypeOfPhase("playoff")
                            } else {
                                setTypeOfPhase("league");
                            }
                        }
                    });
                    axios.get(`${process.env.REACT_APP_MAIN_URL}/admin/get-competition-teams?competitionId=${params.competitionId}`)
                        .then((result) => {
                            if (editingGroupsParam && groups.length === 0 && myPhaseLocal !== null) {
                                let groupsFromPhase = [];
                                myPhaseLocal.league.groups.map((oneGroup) => {
                                    let teamsNew = [];
                                    oneGroup.group.teams.map((oneTeam) => {
                                        result.data.teams.map((fullTeam) => {
                                            if (oneTeam === fullTeam._id) {
                                                teamsNew.push(fullTeam);
                                            }
                                        })
                                    })

                                    let preparedGroup = Object.assign({}, oneGroup.group);
                                    preparedGroup.teams = teamsNew;
                                    groupsFromPhase.push(preparedGroup)
                                })
                                setGroups(groupsFromPhase)
                            }
                            if (teamDiscipline || (!isAtletikaPlivanje(firstResult.data.competition) && !isOneToOneSport(firstResult.data.competition, forceTeamSport))) {
                                setAllTeams(result.data.teams);
                            } else {
                                let disciplineValue = (location && location.state && location.state.discipline && location.state.discipline.value ? location.state.discipline.value : null);
                                let myPlayers = getPlayersFromTeams(result.data.teams, firstResult.data.competition._id, disciplineValue);
                                setAllTeams(myPlayers)
                            }
                            setAllTeamsPreserved(result.data.teams);
                            let isNewPlayoff = games.length === 0 && (isLocalPlayoff || typeOfPhase === "playoff") && !isEditLocal;
                            if (isNewPlayoff) {
                                preparePlayoffGames(firstResult.data.competition);
                            } else {
                                setIsThirdPlaceGameButton(true)
                                firstResult.data.competition.phases.map((singlePhase) => {
                                    if (singlePhase.name === params.phaseName && isLocalPlayoff) {
                                        let myMatches = singlePhase.playoff.games;
                                        console.log("Matches", myMatches)
                                        let gamesPrepared = [];
                                        myMatches.map((myMatch) => {
                                            if (myMatch.game.fixture && !myMatch.isThirdPlace) {
                                                if (!gamesPrepared[myMatch.game.fixture - 1]) {
                                                    gamesPrepared[myMatch.game.fixture - 1] = [];
                                                }
                                                myMatch.game.teams = [];
                                                let home = myMatch.game.homeTeam;
                                                if (home == null) {
                                                    home = myMatch.game.homePlayer
                                                }
                                                let away = myMatch.game.awayTeam;
                                                if (away == null) {
                                                    away = myMatch.game.awayPlayer
                                                }
                                                myMatch.game.teams.push(home);
                                                myMatch.game.teams.push(away);
                                                gamesPrepared[myMatch.game.fixture - 1].push(myMatch.game);
                                            } else {
                                                setIsThirdPlaceGame(true)
                                                setIsThirdPlaceGameButton(false)
                                                setGameThirdPlace(myMatch.game)
                                            }
                                        })
                                        setGames(gamesPrepared)
                                    }
                                });
                            }
                            fixFooterButtons()
                        })
                })
        }
    }, [])


    if (typeOfPhase == null) {
        return null;
    }

    if (typeOfPhase == "playoff" && (games.length === 0)) {
        return null;
    }
    let numberOfRounds = 0;
    if (typeOfPhase === "playoff") {
        numberOfRounds = [...Array(Math.trunc(getNumberOfRounds())).keys()].reverse();
    }


    const axiosPromise = (match) => {
        return new Promise((resolve) => {
            let addEdit = `add`;
            if (isEditPlayoff) {
                addEdit = "edit";
            }
            axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/${addEdit}-game`, {
                sport: getSportName(competition.sport.name),
                competition: competition._id,
                ...match
            }).then((result) => {
                let id = result.data.gameId;
                window.preparedMatches = preparedMatches.map((preparedMatch) => {
                    if (preparedMatch.previousGameHomeIdCustom && preparedMatch.previousGameHomeIdCustom === (match.customId)) {
                        preparedMatch.previousGameHome = id;
                    } else if (preparedMatch.previousGameAwayIdCustom && preparedMatch.previousGameAwayIdCustom === (match.customId)) {
                        preparedMatch.previousGameAway = id;
                    }
                    return preparedMatch;
                })
                resolve();
            }).catch((e) => {
                console.log(e)
            });
        });
    }


    const axiosPromiseBerger = (oneMatch) => {
        return new Promise((resolve) => {
            axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/add-game`, {
                sport: getSportName(competition.sport.name),
                competition: competition._id,
                ...oneMatch
            }).then((result) => {
                resolve();
            }).catch((e) => {
                if (e.response && e.response.data && e.response.data.message) {
                    window.alert(e.response.data.message);
                } else {
                    window.alert("Nesto je poslo po krivu. Molimo probajte ponovno.")
                }
            });
        })
    }

    function sequencePromises(promise, number) {
        return new Promise((resolve) => {
            resolve(promise.then(() => axiosPromise(window.preparedMatches[number])));
        });
    }

    function sequencePromisesBerger(promise, number) {
        return new Promise((resolve) => {
            resolve(promise.then(() => axiosPromiseBerger(window.preparedMatches[number])));
        });
    }


    function handleGamesPlayoff(preparedMatches) {
        window.preparedMatches = preparedMatches;
        let arrayMatches = [...preparedMatches.keys()]
        arrayMatches.reduce(sequencePromises, Promise.resolve()).then(() => {
            setLoading(false);
            MySwal.fire({
                icon: 'success',
                title: 'Uspješno',
                text: isEditPlayoff ? "Playoff uređen" : "Playoff dodan",
                customClass: {
                    confirmButton: 'btn btn-success'
                }
            }).then(() => {
                window.location.reload();
            })
        });
    }

    const addGameThirdPlace = () => {
        let payload = {
            ...gameThirdPlace, 
            homeTeam: gameThirdPlace.homeTeam?._id,
            homeTeamId: gameThirdPlace.homeTeam?._id,
            awayTeam: gameThirdPlace.awayTeam?._id,
            awayTeamId: gameThirdPlace.awayTeam?._id
        }
        let addEdit = `add`;
        if (gameThirdPlace._id) {
            addEdit = "edit";
            payload = {
                ...payload,
                gameId: gameThirdPlace._id
            }
        }
        let axiosRequest = axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/${addEdit}-game`, {
            sport: getSportName(competition.sport.name),
            competition: competition._id,
            ...payload
        }).then(res => {
            console.log("Game succesfully added!")
            return true
        

        }).catch(err => {
            console.log("Third place game err", err);
            return false
    })

        return axiosRequest
    }


    async function handlePrijenosBodova(myPhaseId) {
        let groupsFrom = []
        fazaPrijenosBodova.value.league.groups.map((singleGroup) => {
            groupsFrom.push(singleGroup.group.name)
        })
     
        let competitionResult = await axios.get(`${process.env.REACT_APP_MAIN_URL}/admin/get-one-competition?competitionId=${params.competitionId}`);
        let newPhase = null;
        competitionResult.data.competition.phases.map((onePhase) => {
            if (onePhase._id == myPhaseId) {
                newPhase = onePhase;
            }
        })
        

        let groupsTo = []
        newPhase.league.groups.map((singleGroup) => {
            groupsTo.push(singleGroup.group.name)
        })

        let leagueTableResultsFrom = [];
        let leagueTableResultsTo = [];

        for (let i = 0; i < groupsFrom.length; i++) {
            let leagueTableResult = await axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/get-league-table`, {
                sport: getSportName(competition.sport.name),
                competition: competition._id,
                league: fazaPrijenosBodova.value.league._id,
                group: groupsFrom[i]
            });
            leagueTableResultsFrom.push(leagueTableResult.data.table._id);

        }

        for (let i = 0; i < groupsTo.length; i++) {
            let leagueTableResult = await axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/get-league-table`, {
                sport: getSportName(competition.sport.name),
                competition: competition._id,
                league: newPhase.league._id,
                group: groupsTo[i]
            });
            leagueTableResultsTo.push(leagueTableResult.data.table._id);
        }

        for (let i = 0; i < leagueTableResultsTo.length; i++) {
            let transferTable = await axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/transfer-table`, {
                tablesFrom: leagueTableResultsFrom,
                tableTo: leagueTableResultsTo[i],
                sport: getSportName(competition.sport.name)
            })
        }
        history.replace(`/natjecanja/detalji/faza-natjecanja-grupe/${competition._id}/${myPhaseId}`);
    }




    function addGamesBerger(preparedMatches) {
        window.preparedMatches = preparedMatches;
        let arrayMatches = [...preparedMatches.keys()]
        arrayMatches.reduce(sequencePromisesBerger, Promise.resolve()).then(() => {
            setLoading(false);
            history.replace(`/natjecanja/detalji/faza-natjecanja-grupe/${competition._id}/${preparedMatches[0].phaseId}`);
        });
    }


    let numberOfNewGroups = 0;
    groups.map((oneGroup) => {
        if (oneGroup.isNewGroup) {
            numberOfNewGroups++;
        }
    }
    )

    return (
        <Fragment>
            <NewGroupModal
                isAtletikaPlivanje={() => {
                    return isAtletikaPlivanje(competition);
                }}
                groups={groups}
                setGroups={setGroups}
                isOpen={isNewGroupModalOpen}
                toggle={() => {
                    setIsNewGroupModalOpen(!isNewGroupModalOpen);
                }}
            />
            <div className={""}>
                <div className={"row"}>
                    <div className={isEditPlayoff ? "col-12" : "col-9"}>
                        <Card style={{
                            overflowY: "visible"
                        }}>
                            <CardHeader>
                                <span>
                                    <CardTitle style={{
                                        display: "inline",
                                        marginRight: "75px"
                                    }}
                                        tag='h4'>{location.state ? location.state.name : ""} {(location && location.state && location.state.discipline) ? location.state.discipline.value : ""}</CardTitle>
                                    {false && typeOfPhase === "playoff" && !isEditPlayoff &&
                                        <Fragment>
                                            <span style={{ margin: "15px", marginRight: "70px" }}
                                                className={"text-center justify-content-center"}>
                                                Drag & drop
                                                <Input
                                                    style={{ width: "15px", height: "15px", marginLeft: "10px" }}
                                                    id={"basic-cb-checked1"}
                                                    type={"radio"}
                                                    value={"drag_drop"}
                                                    theme={selectThemeColors}
                                                    checked={isDragDrop}
                                                    onChange={(e) => {
                                                        setIsDragDrop(!isDragDrop)
                                                    }}
                                                />
                                            </span>
                                            <span style={{ margin: "15px" }}
                                                className={"text-center justify-content-center align-content-center"}>
                                                <Input
                                                    style={{ width: "15px", height: "15px", marginRight: "15px" }}
                                                    id={"basic-cb-checked00992"}
                                                    type={"radio"}
                                                    value={"playoff"}
                                                    theme={selectThemeColors}
                                                    checked={!isDragDrop}
                                                    onChange={(e) => {
                                                        setIsDragDrop(!isDragDrop)
                                                    }}
                                                />
                                                <span style={{ marginLeft: "10px" }}>Dropdown</span>
                                            </span>
                                        </Fragment>
                                    }

                                </span>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col className='mb-1 text-center justify-content-center align-content-center' md='4'
                                        sm='4'>
                                        {typeOfPhase === "league" && location.state && location.state.prijenosBodova &&
                                            <Select
                                                theme={selectThemeColors}
                                                className='react-select'
                                                classNamePrefix='select'
                                                value={fazaPrijenosBodova}
                                                placeholder={"Odaberi fazu za prijenos bodova"}
                                                onChange={(data) => {
                                                    setFazaPrijenosBodova(data)
                                                }}
                                                name='clear'
                                                options={preparedPhases}
                                                isClearable={false}
                                            />
                                        }
                                    </Col>
                                    <Col md={1} />
                                    <Col>
                                        {typeOfPhase === "league" && (!isEditingGroups || numberOfNewGroups < 1) &&
                                            <Button.Ripple color='primary' onClick={() => {
                                                setIsNewGroupModalOpen(true);
                                            }}>
                                                {(isAtletikaPlivanje(competition)) ? "Dodaj novu utrku" : "Dodaj novu grupu"}
                                            </Button.Ripple>
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='mb-1' md='6' sm='12'>
                                    </Col>
                                </Row>

                                {typeOfPhase === "playoff" &&
                                    <PlayoffScreen
                                        isEdit={isEditPlayoff}
                                        phaseName={params.phaseName}
                                        competition={competition}
                                        numberOfTeams={numberOfTeams}
                                        numberOfRounds={numberOfRounds}
                                        getNumberOfGamesInARound={getNumberOfGamesInARound}
                                        games={games}
                                        setGames={setGames}
                                        allTeams={allTeams}
                                        setAllTeams={setAllTeams}
                                        isThirdPlaceGame={isThirdPlaceGame}
                                        gameThirdPlace={gameThirdPlace}
                                        setGameThirdPlace={setGameThirdPlace}
                                    />
                                }
                                {typeOfPhase === "league" &&
                                    <LeagueScreen
                                        setAllTeams={setAllTeams}
                                        allTeams={allTeams}
                                        currentPhase={currentEditingPhase}
                                        isEditingGroups={isEditingGroups}
                                        loading={loading}
                                        groups={groups}
                                        setGroups={setGroups}
                                    />
                                }
                            </CardBody>
                        </Card>
                    </div>
                    {!isEditPlayoff &&
                        <div className={"col-3"}>
                            <Card style={{
                                backgroundColor: "whitesmoke",
                                overflowY: "scroll",
                                maxHeight: "700px"

                            }}>
                                <CardHeader>
                                    <CardTitle
                                        tag='h4'>{"Svi sudionici"}</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    {typeOfPhase === "league" &&
                                        <ReactSortable
                                            className='list-group sortable'
                                            multiDrag
                                            group='shared-multi-drag-group'
                                            list={allTeams}
                                            setList={setAllTeams}
                                        >
                                            {allTeams.map((item, index) => {
                                                return (
                                                    <div
                                                        style={{
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap"
                                                        }}
                                                        key={item._id}
                                                        className={"row justify-content-center align-content-center single-team"}>
                                                        <Col md='2'>
                                                            <img style={{
                                                                width: "12px",
                                                                height: "12px"
                                                            }} className={"my-auto"} src={dots} />
                                                        </Col>
                                                        <Col md={"10"}>
                                                            <span>{item.shortName ? item.shortName : item.name} {item.surname ? item.surname : ""} {item.customTeam ? (" - " + item.customTeam) : ""}</span>
                                                        </Col>
                                                    </div>

                                                )
                                            })}
                                        </ReactSortable>
                                    }
                                    {typeOfPhase === "playoff" &&
                                        <div
                                            className='list-group sortable'
                                        >
                                            {allTeams.map((item, index) => {
                                                return (
                                                    <div
                                                        style={{
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap"
                                                        }}
                                                        id={item._id}
                                                        draggable={"true"}
                                                        onDragStart={(e) => {
                                                            e.dataTransfer.setData("dragId", e.target.id);
                                                        }}
                                                        onDragOver={(e) => {

                                                            e.preventDefault(); // Necessary. Allows us to drop.
                                                            return false;
                                                        }}
                                                        key={item._id}
                                                        className={"row justify-content-center align-content-center single-team"}>
                                                        <Col md='2'>
                                                            <img style={{
                                                                width: "12px",
                                                                height: "12px"
                                                            }} className={"my-auto"} src={dots} />
                                                        </Col>
                                                        <Col md={"10"}>
                                                            <span>{item.shortName ? item.shortName : item.name} {item.surname ? item.surname : ""}</span>
                                                        </Col>
                                                    </div>

                                                )
                                            })}
                                        </div>
                                    }
                                </CardBody>
                            </Card>
                        </div>
                    }
                </div>
                {typeOfPhase === "playoff" && isThirdPlaceGameButton &&  
                <Row>
                    <Button style={{margin: "0 auto"}} onClick={() => {
                        setIsThirdPlaceGameButton(!isThirdPlaceGameButton)
                        setIsThirdPlaceGame(!isThirdPlaceGame)
                        if (!isThirdPlaceGame) {
                            setGameThirdPlace({
                                homeTeam: {
                                    name: "?",
                                    shortName: "?"
                                },
                                awayTeam: {
                                    name: "?",
                                    shortName: "?"
                                },
                                homeTeamId: null,
                                awayTeamId: null,
                                location: "",
                                customId: makeId(20),
                                fixture: null,
                                halftimeDuration: duration != "" ? duration : 20,
                                season: competition.season._id,
                                organisation: competition.organisation._id,
                                phaseId: currentEditingPhase,
                                date: null,
                                isThirdPlace: true,
                            })
                        } else {
                            setGameThirdPlace()
                        }
                        }}>
                        Dodaj utakmicu za 3. mjesto
                    
                    </Button>
                </Row>
                }
                {!hideFooter &&
                    <FooterButtons
                        loading={loading}
                        forwardClick={() => {
                            let newGroups = JSON.parse(JSON.stringify(groups));
                            newGroups = newGroups.filter((singleGroup) => {
                                return singleGroup.isNewGroup;
                            })
                            let groupsPrepared = newGroups.map((myGroup) => {
                                myGroup.teams = myGroup.teams.map((myTeam) => {
                                    return myTeam._id;
                                });
                                myGroup.numberOfTeams = myGroup.teams.length;
                                return {
                                    group: myGroup
                                }
                            });

                            let groupsPrepared2 = newGroups.map((myGroup) => {
                                myGroup.players = myGroup.teams.map((myTeam) => {
                                    return myTeam;
                                });
                                myGroup.numberOfPlayers = myGroup.players.length;
                                return {
                                    group: myGroup
                                }
                            });

                            let dataBody = {
                                name: params.phaseName,
                                type: isAtletikaPlivanje(competition) ? "other" : typeOfPhase,
                                sequence: competition.sequence,
                                season: competition.season.name,
                                hasBerger: isBerger,
                                sport: getSportName(competition.sport.name),
                                hasReturnMatches: uzvrati,
                                halftimeDuration: duration != "" ? duration : 20,
                                competitionId: competition._id,
                                games: []
                            };
                            if (!isAtletikaPlivanje(competition)) {
                                if (typeOfPhase == "league") {
                                    dataBody.league = {
                                        name: competition.name
                                    }
                                    dataBody.groups = groupsPrepared;
                                    dataBody.groups2 = groupsPrepared2;
                                } else {
                                    let teamsIds = [];
                                    allTeamsPreserved.map((myTeam) => {
                                        teamsIds.push(myTeam._id)
                                    });
                                    dataBody.teams = teamsIds;
                                    dataBody.playoff = {
                                        name: competition.name
                                    }
                                }
                            }
                            if (isAtletikaPlivanje(competition)) {
                                if (newGroups.length === 0) {
                                    window.alert("Molimo odaberite barem jednu utrku");
                                    return;
                                }
                                if (location.state.discipline && location.state.discipline.value) {
                                    dataBody.discipline = location.state.discipline.value;
                                }
                                setLoading(true);
                                let allSuccessful = [];
                                let urlPartPhase = `add-phase`;
                                if (isEditingGroups) {
                                    urlPartPhase = "add-group-to-phase";
                                }
                                axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/${urlPartPhase}`, dataBody).then((result) => {
                                    newGroups.map((oneGroup) => {
                                        let swimmers = oneGroup.teams.map((mySwimmer) => {
                                            return {
                                                swimmer: mySwimmer._id
                                            }
                                        })
                                        let athletes = oneGroup.teams.map((mySwimmer) => {
                                            return {
                                                athlete: mySwimmer._id
                                            }
                                        })

                                        let teams = [];
                                        if (teamDiscipline) {
                                            teams = oneGroup.teams.map((oneSwimmer) => {
                                                return oneSwimmer._id;
                                            })
                                        }
                                        let myPhaseId = result.data.phaseId;
                                        axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/add-game`, {
                                            sport: getSportName(competition.sport.name),
                                            location: (competition.location && competition.location.fullName) ? competition.location.fullName : competition.location,
                                            discipline: oneGroup.name + " (" + location.state.discipline.value + ")",
                                            date: null,
                                            organisation: competition.organisation._id,
                                            season: competition.season._id,
                                            competition: competition._id,
                                            phaseId: myPhaseId,
                                            swimmers: teamDiscipline ? [] : swimmers,
                                            athletes: teamDiscipline ? [] : athletes,
                                            teams: teams,
                                            isRelay: teamDiscipline

                                        }).then((result) => {
                                            allSuccessful.push(true)
                                            if (allSuccessful.length === groups.length) {
                                                history.replace(`/natjecanja/detalji/faza-natjecanja-grupe/${competition._id}/${myPhaseId}`);
                                            }
                                        }).catch((e) => {
                                            window.alert("Nesto je poslo po krivu. Molim probajte ponovno.");
                                        });


                                    })
                                })
                                return;
                            }

                            let preparedMatches = [];
                            if (typeOfPhase === "league") {
                                if (newGroups.length === 0) {
                                    window.alert("Molimo odaberite barem jednu grupu");
                                    return;
                                }
                                let groupHasNoTeams = false;
                                newGroups.map((singleGroup, index) => {
                                    if (singleGroup.teams == null || singleGroup.teams.length === 0 || singleGroup.teams.length === 1) {
                                        groupHasNoTeams = true;
                                    }
                                    let preparedTeams = [];
                                    singleGroup.teams.map((singleTeam) => {
                                        preparedTeams.push({
                                            id: singleTeam,
                                            name: singleTeam
                                        })
                                    })

                                    if (isBerger) {
                                        let teamsForBerger = [...singleGroup.teams];
                                        if ((teamsForBerger.length % 2) != 0) {
                                            teamsForBerger.push({
                                                id: "something",
                                                name: "dummy team",
                                                shortName: "dummy team"
                                            })
                                        }
                                        if (uzvrati) {
                                        }
                                        let bergerCreator = BergerCreator(teamsForBerger);
                                        if (uzvrati) {
                                            let bergerCreator2 = BergerCreator(teamsForBerger);
                                            bergerCreator = bergerCreator.concat(bergerCreator2)
                                        }
                                        bergerCreator.map((roundMatches, index) => {
                                            roundMatches.map((roundMatch, index2) => {
                                                let myIndex1 = parseInt(roundMatch.split("-")[0]) - 1;
                                                let myIndex2 = parseInt(roundMatch.split("-")[1]) - 1;
                                                let home = singleGroup.teams[myIndex1];
                                                let away = singleGroup.teams[myIndex2];
                                                if (home && away && home.id !== "something" && away.id !== "something") {
                                                    if (uzvrati && index >= (bergerCreator.length / 2)) {
                                                        home = singleGroup.teams[myIndex2];
                                                        away = singleGroup.teams[myIndex1];
                                                    }
                                                    let homeTeamCore = null
                                                    if (typeof home === "object") {
                                                        homeTeamCore = home.coreTeam;
                                                        home = home._id;
                                                    }

                                                    let awayTeamCore = null
                                                    if (typeof away === "object") {
                                                        awayTeamCore = away.coreTeam;
                                                        away = away._id;
                                                    }

                                                    preparedMatches.push({
                                                        hasStared: false,
                                                        homeTeamCore,
                                                        awayTeamCore,
                                                        homeTeamId: home,
                                                        awayTeamId: away,
                                                        homeTeam: home,
                                                        awayTeam: away,
                                                        homePlayer: home,
                                                        homePlayerId: home,
                                                        awayPlayer: away,
                                                        awayPlayerId: away,
                                                        location: (competition.location && competition.location.fullName) ? competition.location.fullName : competition.location,
                                                        date: (roundMatch.date && Array.isArray(roundMatch.date)) ? roundMatch.date[0] : (roundMatch.date ? roundMatch.date : null),
                                                        fixture: index + 1,
                                                        group: singleGroup.name,
                                                        competition: competition._id,
                                                        organisation: competition.organisation._id,
                                                        season: competition.season._id
                                                    })
                                                }
                                            })
                                        });
                                    }
                                })

                                if (groupHasNoTeams) {
                                    window.alert("Molimo unesite barem 2 tima u svaku grupu")
                                    return;
                                }
                            } else {
                                let gamesRound1NotFilled = false;
                                games.map((round, index) => {
                                    round.map((myGame, index2) => {
                                        let homeTeamId = myGame.teams[0] ? myGame.teams[0]._id : null;
                                        let awayTeamId = myGame.teams[1] ? myGame.teams[1]._id : null;

                                        if (index === 0 && (homeTeamId == null && awayTeamId == null)) {
                                            gamesRound1NotFilled = true;
                                        }
                                        if (index === 1 && (homeTeamId == null)) {
                                            let myPreviousGameHome = games[index - 1][index2 * 2];
                                            if ((myPreviousGameHome.teams[0]?._id == null || myPreviousGameHome.teams[1]?._id == null)) {
                                                homeTeamId = myPreviousGameHome.teams[0]?._id ? myPreviousGameHome.teams[0]?._id : myPreviousGameHome.teams[1]?._id;
                                            }
                                        }
                                        if (index === 1 && (awayTeamId == null)) {
                                            let myPreviousGameAway = games[index - 1][(index2 * 2) + 1];
                                            if (myPreviousGameAway.teams[0]?._id == null || myPreviousGameAway.teams[1]?._id == null) {
                                                awayTeamId = myPreviousGameAway.teams[0]?._id ? myPreviousGameAway.teams[0]?._id : myPreviousGameAway.teams[1]?._id;
                                            }
                                        }
                                        let previousGameHome = null;
                                        let previousGameAway = null;
                                        let preparedDate = (myGame.date && Array.isArray(myGame.date)) ? myGame.date[0] : (myGame.date ? myGame.date : null);
                                        preparedMatches.push({
                                            gameId: myGame._id,
                                            customId: myGame.customId,
                                            hasStarted: false,
                                            homeTeamId,
                                            awayTeamId,
                                            homePlayer: homeTeamId,
                                            homeTeam: homeTeamId,
                                            awayTeam: awayTeamId,
                                            homePlayerId: homeTeamId,
                                            awayPlayer: awayTeamId,
                                            awayPlayerId: awayTeamId,
                                            location: myGame.location,
                                            date: preparedDate,
                                            previousGameHome,
                                            previousGameAway,
                                            previousGameHomeIdCustom: index !== 0 ? games[index - 1][index2 * 2].customId : null,
                                            previousGameAwayIdCustom: index !== 0 ? games[index - 1][(index2 * 2) + 1].customId : null,
                                            fixture: index + 1,
                                            season: competition.season._id,
                                            organisation: competition.organisation._id,
                                            competition: competition._id
                                        })
                                    });
                                });

                                if (gamesRound1NotFilled) {
                                    window.alert("Svaka utakmica mora imati barem jedan team u prvoj rundi")
                                    return;
                                }
                            }

                            setLoading(true);
                            if (isEditPlayoff) {
                                if (gameThirdPlace) {
                                    addGameThirdPlace()
                                }                       
                               setTimeout(() => {
                                handleGamesPlayoff(preparedMatches)
                               }, 1000)
                           
                              
                            } else {
                                let urlPartPhase = `add-phase`;
                                if (isEditingGroups) {
                                    urlPartPhase = "add-group-to-phase ";
                                    dataBody.phaseId = currentEditingPhase._id
                                    dataBody.group = dataBody.groups[0];
                                }

                                axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/${urlPartPhase}`, dataBody).then((result) => {
                                  
                                    let myPhaseId = result.data.phaseId;
                                    if (isEditingGroups) {
                                        myPhaseId = currentEditingPhase._id
                                    }
                                    preparedMatches = preparedMatches.map((myMatch, index) => {
                                        myMatch.phaseId = myPhaseId;
                                        return myMatch;
                                    })
                                    if (typeOfPhase === "league") {
                                        if (isBerger) {
                                            addGamesBerger(preparedMatches);
                                        } else {
                                            if (fazaPrijenosBodova !== "" && fazaPrijenosBodova != null) {
                                                handlePrijenosBodova(myPhaseId);
                                            } else {
                                                history.replace(`/natjecanja/detalji/faza-natjecanja-grupe/${competition._id}/${myPhaseId}`);
                                            }
                                        }
                                    } else {

                                        handleGamesPlayoff(preparedMatches);
                                    }
                                }).catch((e) => {
                                    window.alert("Nesto je poslo po krivu. Molim probajte ponovno.");
                                });
                            }
                        }
                        }
                        forwardLabel={isEditPlayoff ? "Uredi" : "Potvrdi"}
                        backClick={() => {
                            history.goBack();
                        }}
                    />
                }
            </div>
        </Fragment>
    );
}

export default CompetitionPhase;